import { Link } from "react-router-dom";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ChangesetLink(props) { return /*#__PURE__*/ _jsxs(Link, { to: `/project/${props.projectId}/shop-drawing/changeset/${props.changeset.id}/preview`, children: ["Changeset #", props.changeset.projSeqNumber, props.changeset.name ? ": " + props.changeset.name : ""] }); }
